require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./lorem-ipsum.json") })
        }
      }, "path---lorem-ipsum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---lorem-ipsum!./.cache/json/lorem-ipsum.json
// module id = 333
// module chunks = 231608221292675